import { Component, EventEmitter, Input, Output, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PesquisaService } from 'src/app/services/pesquisa.service';
import { JwtService } from 'src/app/jwt.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConsultaDetalhada } from 'src/app/persistences/consulta-detalhada';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.css']
})
export class SearchBarComponent implements OnInit {
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;
  @Output()
  idsPesquisaEmitter = new EventEmitter<number[]>();
  @Output()
  isLoadingEmitter = new EventEmitter<boolean>();
  @Output()
  ocultaAbasEmitter = new EventEmitter<boolean>();
  @Input()
  consultaDetalhada: ConsultaDetalhada;
  @Output()
  pesquisaRealizada = new EventEmitter<void>();
  @Input() 
  qtdFiltros: number;
  @Output() 
  openDialog = new EventEmitter<void>();
  @Input() 
  aplicarFiltros: (filtros: any) => void;
  @Input() 
  utilizaPesquisaAvancada: boolean;
  
  idsPesquisa: number[];
  strPesquisa: string;

  constructor(
    private pesquisaService: PesquisaService,
    private jwtService: JwtService,
    private router: Router,
    private route: ActivatedRoute,
    private configService: ConfigService
  ) { }

  ngOnInit(){    
    if(localStorage.getItem('pesquisa') !== null && localStorage.getItem('pesquisa') !== ''){
        this.strPesquisa = localStorage.getItem('pesquisa')
        this.pesquisar();
    }
    if(this.configService.getConfig().getUtilizaPesquisaAvancadaVeiculos === "S"){
      this.utilizaPesquisaAvancada = true;
    }else{
      this.utilizaPesquisaAvancada = false;
    }
  }

  pesquisar() {
    this.redirectToHome();
    this.ocultaAbasEmitter.emit(false);
    this.isLoadingEmitter.emit(true);
    this.idsPesquisa = new Array<number>();
    this.pesquisaService.pesquisa(this.strPesquisa, this.consultaDetalhada).subscribe(
      (produtos) => {

        produtos.forEach(item => {
          this.idsPesquisa.push(item.id_item);
        });
        this.pesquisaService.setProdutosPesquisados(produtos);
        this.idsPesquisaEmitter.emit(this.idsPesquisa);
        this.isLoadingEmitter.emit(false);
        this.pesquisaRealizada.emit();
      },
      (error) => {
        this.isLoadingEmitter.emit(false);
        this.jwtService.validarAcessToken(error);
      }
    );
  }

  redirectToHome(){
    if(this.route.snapshot.url.join('/') === 'carrinho' || this.route.snapshot.url.join('/') === 'pagamento-pix'){
      localStorage.setItem('pesquisa',this.strPesquisa)
      this.router.navigateByUrl('/');
    } else{
      localStorage.removeItem('pesquisa');
    }
  }

  abrirDialog(): void {
    this.openDialog?.emit();
  }

  aplicarFiltrosInterno(event: Event): void {
    this.aplicarFiltros?.(event);
  }
}
